import { initCollapsibleArea } from '../../scripts/utils/collapsibleArea';
import YTPlayer from '../../scripts/components/YTPlayer';

initCollapsibleArea();
YTPlayer.init();
